module.exports = __webpack_public_path__ + "static/media/logo-white.186f1994.png";